module.exports = __webpack_public_path__ + "static/media/janis-logo-beta.29ada900.svg";